import axios from 'axios';
import config from "../environment/config";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || config.API_URL || 'http://localhost:8082';

const SUBSCRIPTION_API = `${API_BASE_URL}/api/seo-user/subscription`;

/**
 * Fetch logged-in user's subscription
 * API: GET /api/subscription/my
 */
export const getMySubscription = async () => {
  try {
    const response = await axios.get(`${SUBSCRIPTION_API}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json"
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching subscription:', error);
    throw error;
  }
};
